/*
 * Copyright © Soft-logic LLC 2008-2022.
 * All rights to this software are owned by Soft-logic. Illegal copying and distribution is prohibited.
 * More information on the site http://paylogic-software.com/
 */

class MenuItem {
    constructor({
                    id,
                    name,
                    description,
                    code,
                    phoneRequired,
                    logo
                }) {
        this.id = id
        this.name = name
        this.description = description
        this.code = code
        this.phoneRequired = phoneRequired
        this.logo = logo
    }

    getId() {
        return this.id
    }

    getName() {
        return this.name
    }

    getDescription() {
        return this.description
    }

    getCode() {
        return this.code
    }

    getPhoneRequired() {
        return this.phoneRequired
    }

    getLogo() {
        return this.logo
    }
}

export default MenuItem
